import s from './TagsSelect.module.scss';
import { useGetTagsQuery } from '../../redux/apis/tagsApi';
import { Checkbox } from '@mui/material';
import { useTranslation } from 'react-i18next';

export const TagsSelect = ({type, currentTags, setCurrentTags}: any) => {
    // ### State
    const {data: tags, isLoading} = useGetTagsQuery({type})
    
    // ### Effects

    // ### Functions

    // ### Views
    const tagsView = tags?.map((tag: any, index: number) => {
        const isChecked = currentTags?.find((el: any) => el.id === tag.id)
        return(
            <div className={s.tag_wrapper} key={index}>
                <Checkbox 
                    checked={isChecked ? true : false}
                    onClick={(ev: any) => {
                        setCurrentTags(ev.target.checked ? [...currentTags, tag] : currentTags?.filter((el : any) => el.id !== tag.id))
                    }}
                />
                <p className={s.tag}> <span className={s.color} style={{background: tag.color}}></span> {tag.name}</p>
            </div>
        )
    })

    return(
        <div className={s.tags_wrapper}>
            {tagsView}
        </div>
    )
}